import { Box, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';

import ButtonCustom from '@/app/_components/button/ButtonCustom';
import { ReactComponent as PiggyBank } from '@/app/_icons/piggy_bank.svg';

import Styles from '../SellYourCarForm.module.scss';

export const SuccessMessage = () => (
  <Stack spacing={2} textAlign="center">
    <Text fontSize="2xl">
      {`One of our experienced car buying professionals will be in
      contact soon`}
    </Text>
    <Box mx={'auto'}>
      <PiggyBank />
    </Box>
    <Box className={Styles.formActions}>
      <NextLink href="/" passHref>
        <ButtonCustom moduleClass={Styles.ctaBtn}>Home</ButtonCustom>
      </NextLink>
    </Box>
  </Stack>
);
